// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .nav-link {
  color: var(--bs-text-dark) !important;
  font-weight: 400 !important;
}

.nav-link.active {
  color: var(--bs-text-primary) !important;
  font-weight: 600 !important;
} */


/* ul{
  border: 4px solid #545FE5;
  border-radius:50px;
  width:200px;
  height:45px;
  display:flex;
  justify-content:center;
  align-items:center;
  padding:0;
  margin:0;
  cursor:pointer;
  transition:ease 0.2s;
  position:relative;
  background:#fff;
} */

/* ul:before{
  content: 'Click this button!';
  width:100%;
  position:absolute;
  text-align:center;
  font-family:sans-serif;
  color:#fff;
  transition: ease 0.3s;
  bottom:0;
  pointer-events:none;
  z-index:-1;
} */

/* ul:hover::before{
  bottom: -30px;
  color: #545FE5;
}
ul:active::before{
  content: 'Yeah!';
} */


li{
  list-style:none;
  height:20px;
  width:4px;
  border-radius:30px;
  background: #fff;
  margin: 0 3px;
  padding:0;
  animation-name: wave1;
  animation-duration: 0.3s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  transition:ease 0.2s;
}

/* ul:hover > li{
  background:#fff;
}
ul:hover{
  background: #545FE5;
} */

li:nth-child(2) {
    animation-name: wave2;
    animation-delay:0.2s;
}
li:nth-child(3) {
    animation-name: wave3;
  animation-delay:0.23s;
  animation-duration: 0.4s;
}
li:nth-child(4) {
    animation-name: wave4;
    animation-delay:0.1s;
  animation-duration: 0.3s;
}
li:nth-child(5) {
  animation-delay:0.5s;
}
li:nth-child(6) {
    animation-name: wave2;
  animation-duration: 0.5s;
}
li:nth-child(8) {
    animation-name: wave4;
  animation-delay:0.4s;
  animation-duration: 0.25s;
}
li:nth-child(9) {
    animation-name: wave3;
  animation-delay:0.15s;
}

@keyframes wave1 {
    from {transform:scaleY(1);}
    to {transform:scaleY(0.5);}
}
@keyframes wave2 {
    from {transform:scaleY(0.3);}
    to {transform:scaleY(0.6);}
}
@keyframes wave3 {
    from {transform:scaleY(0.6);}
    to {transform:scaleY(0.8);}
}
@keyframes wave4 {
    from {transform:scaleY(0.2);}
    to {transform:scaleY(0.5);}
}


.hover-rotate-me img {
  transition: all 0.5s ease-in-out !important;
}
.hover-rotate-me:hover img {
  transform: rotate(360deg) scale(1.4)
}


.dynamic-gradient-bg {
  background: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
  background-size: 400% 400%;
  animation: gradient 15s ease infinite;
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/shared/partials/dynamic-ai-button/dynamic-ai-button.component.css"],"names":[],"mappings":"AAAA;;;;;;;;GAQG;;;AAGH;;;;;;;;;;;;;;GAcG;;AAEH;;;;;;;;;;;GAWG;;AAEH;;;;;;GAMG;;;AAGH;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,wBAAwB;EACxB,mCAAmC;EACnC,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;;;;;GAKG;;AAEH;IACI,qBAAqB;IACrB,oBAAoB;AACxB;AACA;IACI,qBAAqB;EACvB,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;IACI,qBAAqB;IACrB,oBAAoB;EACtB,wBAAwB;AAC1B;AACA;EACE,oBAAoB;AACtB;AACA;IACI,qBAAqB;EACvB,wBAAwB;AAC1B;AACA;IACI,qBAAqB;EACvB,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;IACI,qBAAqB;EACvB,qBAAqB;AACvB;;AAEA;IACI,MAAM,mBAAmB,CAAC;IAC1B,IAAI,qBAAqB,CAAC;AAC9B;AACA;IACI,MAAM,qBAAqB,CAAC;IAC5B,IAAI,qBAAqB,CAAC;AAC9B;AACA;IACI,MAAM,qBAAqB,CAAC;IAC5B,IAAI,qBAAqB,CAAC;AAC9B;AACA;IACI,MAAM,qBAAqB,CAAC;IAC5B,IAAI,qBAAqB,CAAC;AAC9B;;;AAGA;EACE,2CAA2C;AAC7C;AACA;EACE;AACF;;;AAGA;EACE,uEAAuE;EACvE,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;AACA,g7JAAg7J","sourcesContent":["/* .nav-link {\n  color: var(--bs-text-dark) !important;\n  font-weight: 400 !important;\n}\n\n.nav-link.active {\n  color: var(--bs-text-primary) !important;\n  font-weight: 600 !important;\n} */\n\n\n/* ul{\n  border: 4px solid #545FE5;\n  border-radius:50px;\n  width:200px;\n  height:45px;\n  display:flex;\n  justify-content:center;\n  align-items:center;\n  padding:0;\n  margin:0;\n  cursor:pointer;\n  transition:ease 0.2s;\n  position:relative;\n  background:#fff;\n} */\n\n/* ul:before{\n  content: 'Click this button!';\n  width:100%;\n  position:absolute;\n  text-align:center;\n  font-family:sans-serif;\n  color:#fff;\n  transition: ease 0.3s;\n  bottom:0;\n  pointer-events:none;\n  z-index:-1;\n} */\n\n/* ul:hover::before{\n  bottom: -30px;\n  color: #545FE5;\n}\nul:active::before{\n  content: 'Yeah!';\n} */\n\n\nli{\n  list-style:none;\n  height:20px;\n  width:4px;\n  border-radius:30px;\n  background: #fff;\n  margin: 0 3px;\n  padding:0;\n  animation-name: wave1;\n  animation-duration: 0.3s;\n  animation-iteration-count: infinite;\n  animation-direction: alternate;\n  transition:ease 0.2s;\n}\n\n/* ul:hover > li{\n  background:#fff;\n}\nul:hover{\n  background: #545FE5;\n} */\n\nli:nth-child(2) {\n    animation-name: wave2;\n    animation-delay:0.2s;\n}\nli:nth-child(3) {\n    animation-name: wave3;\n  animation-delay:0.23s;\n  animation-duration: 0.4s;\n}\nli:nth-child(4) {\n    animation-name: wave4;\n    animation-delay:0.1s;\n  animation-duration: 0.3s;\n}\nli:nth-child(5) {\n  animation-delay:0.5s;\n}\nli:nth-child(6) {\n    animation-name: wave2;\n  animation-duration: 0.5s;\n}\nli:nth-child(8) {\n    animation-name: wave4;\n  animation-delay:0.4s;\n  animation-duration: 0.25s;\n}\nli:nth-child(9) {\n    animation-name: wave3;\n  animation-delay:0.15s;\n}\n\n@keyframes wave1 {\n    from {transform:scaleY(1);}\n    to {transform:scaleY(0.5);}\n}\n@keyframes wave2 {\n    from {transform:scaleY(0.3);}\n    to {transform:scaleY(0.6);}\n}\n@keyframes wave3 {\n    from {transform:scaleY(0.6);}\n    to {transform:scaleY(0.8);}\n}\n@keyframes wave4 {\n    from {transform:scaleY(0.2);}\n    to {transform:scaleY(0.5);}\n}\n\n\n.hover-rotate-me img {\n  transition: all 0.5s ease-in-out !important;\n}\n.hover-rotate-me:hover img {\n  transform: rotate(360deg) scale(1.4)\n}\n\n\n.dynamic-gradient-bg {\n  background: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);\n  background-size: 400% 400%;\n  animation: gradient 15s ease infinite;\n}\n\n@keyframes gradient {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
